"use client";

import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import type { MessageCode } from "@/lib/api/error";

/**
 * Renders translated, inline error message(s) for a form field or form-level
 * error. Feed it the codes from {@link useApiFieldErrors}
 * (`fieldErrors[name]` or `generalErrors`). Renders nothing when there are none.
 */
export function FieldErrors({
  codes,
  className,
}: {
  codes?: MessageCode[];
  className?: string;
}) {
  const t = useTranslations();
  if (!codes || codes.length === 0) return null;
  return (
    <p
      className={cn("text-sm text-destructive", className)}
      role="alert"
    >
      {/* errors.code.* is validated against the backend MessageCode enum by scripts/check-translations.ts */}
      {codes.map((code) => t(`errors.code.${code}`)).join(" ")}
    </p>
  );
}
